
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Components/Home';

import FindDiagonictics from './Components/Pages/FindDiagonictics';
import Request from './Components/Pages/Request';

import Patient from './Components/Pages/Patient';
import ViewDiagonstics from './Components/Pages/ViewDiagonstics';
import Login from './Components/Pages/Login';
import Dashboard from './Components/Pages/Dashboard';
import ViewHospitals from './Components/Pages/ViewHospitals';
import FindHospitals from './Components/Pages/FindHospitals';
import { Toaster } from 'sonner';
import Doctor from './Components/Pages/Doctor';
import Profile from './Components/Pages/Profile';
import MusicUpload from './Components/Pages/MusicUpload';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
       <Toaster position="top-right" richColors />
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/login' element={<Login/>}/>
        <Route path='/dashboard' element={<Dashboard/>}/>
        <Route path='/hospitals' element={<FindHospitals/>}/>
        <Route path='/diagonistics' element={<FindDiagonictics/>}/>
        <Route path='/request' element={<Request/>}/>
        <Route path='/patients' element={<Patient/>}/>
         <Route path='/doctors' element={<Doctor/>}/>
         <Route path='/music' element={<MusicUpload/>}/>
         <Route path='/profile' element={<Profile/>}/>

         <Route path='/view-hospitals' element={<ViewHospitals/>}/>
          <Route path='/view-diagonistics' element={<ViewDiagonstics/>}/>
      </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
